export const subscriberCrumbs = [
  {
    name: 'Home',
    path: '/',
  },
  {
    name: 'Sistema',
    path: '/sistema',
  },
  {
    name: 'Sottoscrittore',
    path: '/sistema/eventmanager/sottoscrittore',
  },
];
